import { Button } from "antd";
import { InfoCircleOutlined } from "@ant-design/icons";
import AudbilityStatusTag from "../../../shared/components/AudbilityStatusTag/AudbilityStatusTag";
import { formatDate } from "../../../shared/utils/audbilityFormatters";
import {
  PATIENT_SCREENING_STATUS_CONFIG,
  VIEW_PATIENT_DETAILS_LABEL,
} from "../../constants";
import ExpirationBadge from "../ExpirationBadge/ExpirationBadge";
import classes from "./UserPatients.module.scss";

export const renderScreeningStatus = (status) =>
  PATIENT_SCREENING_STATUS_CONFIG[status] ? (
    <AudbilityStatusTag
      config={PATIENT_SCREENING_STATUS_CONFIG}
      statusKey={status}
      label={PATIENT_SCREENING_STATUS_CONFIG[status].label}
    />
  ) : (
    "-"
  );

export const renderExpiration = (expiration) =>
  expiration ? <ExpirationBadge label={expiration} /> : "-";

export const getUserPatientsColumns = ({ onViewDetails }) => [
  {
    title: "Paciente",
    dataIndex: "name",
    key: "name",
    render: (name) => <strong>{name}</strong>,
  },
  {
    title: "Triagens",
    dataIndex: "screeningsCount",
    key: "screeningsCount",
    render: (screeningsCount) => <strong>{screeningsCount ?? "-"}</strong>,
  },
  {
    title: "Etapa",
    dataIndex: "stage",
    key: "stage",
    render: (stage) => stage || "-",
  },
  {
    title: "Cadastro",
    dataIndex: "createdAt",
    key: "createdAt",
    render: (createdAt) => formatDate(createdAt),
  },
  {
    title: "Triagem status",
    dataIndex: "screeningStatus",
    key: "screeningStatus",
    render: renderScreeningStatus,
  },
  {
    title: "Vencimento",
    dataIndex: "expiration",
    key: "expiration",
    render: renderExpiration,
  },
  {
    title: "Detalhes",
    key: "details",
    align: "center",
    render: (_, record) => (
      <Button
        type="text"
        aria-label={VIEW_PATIENT_DETAILS_LABEL}
        className={classes.DetailsButton}
        icon={<InfoCircleOutlined />}
        onClick={() => onViewDetails(record)}
      />
    ),
  },
];
